export const REDACTED = '[REDACTED]'
export const REDACTED_BODY = '[REDACTED - Contains sensitive data]'
export const SENSITIVE_FIELDS = [
  'password',
  'token',
  'auth',
  'authorization',
  'apikey',
  'secret',
  'key',
  'credential',
  'session',
  'cookie',
]
export const SENSITIVE_REQUEST_HEADERS = ['authorization', 'x-api-key', 'x-auth-token', 'cookie']
export const SENSITIVE_RESPONSE_HEADERS = ['set-cookie', 'x-auth-token']
